import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const PageHeader = (props) => {
    const navigate = useNavigate();
    return (
        <div className="page_header">
            <div className="page_header_content">
                <div className="container">
                    <h2 className="heading">{props.title}</h2>
                    <ul className="breadcrumb">
                        <li onClick={() => navigate("/")} style={{cursor: "pointer"}}>Home</li>
                        <li className="active">{props.active}</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PageHeader;